import React from "react";
import "../../CSS/Industries.css";

function Hospitality() {
    return (
        <>
            
            <section
                className="industry-detail-hero"
                style={{ backgroundColor: '#002952' }}
            >
                <div className="container">
                    <div className="industry-detail-hero-content">

                        <h1>Solutions for Hospitality</h1>
                        <p style={{ color: '#FF7D37' }}>
                            Improve hospitality operations with websites,
                            applications, booking systems, and customized
                            business software.
                        </p>
                    </div>
                </div>
            </section>


            <section className="industry-detail-section">

                <div className="container">

                    <div className="row align-items-center g-5">

                        <div className="col-lg-6">


                            <h2>
                                Digital Solutions for Hospitality Businesses
                            </h2>

                            <p>
                                Hotels, restaurants, resorts, and hospitality
                                businesses need technology that supports both
                                customers and internal operations.
                            </p>

                            <p>
                                We create digital solutions designed to improve
                                customer interaction and business workflows.
                            </p>

                        </div>

                        <div className="col-lg-6">

                            <img
                                src="/images/home/hospitality.png"
                                alt="Hospitality Technology Solutions"
                                className="industry-detail-image"
                            />

                        </div>

                    </div>

                </div>

            </section>


            <section className="industry-features">

                <div className="container">

                    <div className="section-heading text-center">

                        <h2>Technology for<br /> Hospitality</h2>
                    </div>

                    <div className="industry-feature-grid">

                        <div className="industry-feature-card">
                            <i className="bi bi-building"></i>
                            <h3>Hotel Management</h3>
                            <p>Digital solutions for hotel and property operations.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-calendar2-check"></i>
                            <h3>Booking Systems</h3>
                            <p>Booking and reservation solutions for hospitality businesses.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-globe"></i>
                            <h3>Business Websites</h3>
                            <p>Professional websites designed for hospitality businesses.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-people"></i>
                            <h3>Customer Management</h3>
                            <p>Solutions that help businesses manage customer information and interactions.</p>
                        </div>

                    </div>

                </div>

            </section>

        </>
    );
}

export default Hospitality;